import { render } from "./PresentationAccessListModal.vue?vue&type=template&id=64793bfa"
import script from "./PresentationAccessListModal.vue?vue&type=script&lang=js"
export * from "./PresentationAccessListModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__